import { KmPerYear } from '@energy-retailer/constants';
import { z } from 'zod';

export const evDetailsSchema = z
  .object({
    maker: z
      .object({
        id: z.string(),
        name: z.string(),
        disabled: z.boolean(),
      })
      .optional(),
    model: z
      .object({
        id: z.string(),
        name: z.string(),
        disabled: z.boolean(),
      })
      .optional(),
    kmPerYear: z.nativeEnum(KmPerYear).optional(),
    makerOther: z.string().optional(),
    modelOther: z.string().optional(),
  })
  .superRefine((value, ctx) => {
    if (value.maker?.id === 'Other') {
      let isCorrect = true;
      if (value.makerOther === undefined || value.makerOther === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Please provide maker',
          path: ['makerOther'],
        });
        isCorrect = false;
      }
      if (value.modelOther === undefined || value.modelOther === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Please provide model',
          path: ['modelOther'],
        });
        isCorrect = false;
      }
      return isCorrect;
    }
    return true;
  });

export type EvDetailsSchema = z.infer<typeof evDetailsSchema>;
